var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5449 9.71509H1.54492M21.5449 9.71509V15.7151C21.5449 16.2455 21.3342 16.7542 20.9591 17.1293C20.5841 17.5044 20.0754 17.7151 19.5449 17.7151H3.54492C3.01449 17.7151 2.50578 17.5044 2.13071 17.1293C1.75564 16.7542 1.54492 16.2455 1.54492 15.7151V9.71509M21.5449 9.71509L18.0949 2.82509C17.9293 2.49188 17.6741 2.21146 17.3579 2.01537C17.0417 1.81928 16.677 1.71529 16.3049 1.71509H6.78492C6.41284 1.71529 6.04819 1.81928 5.73197 2.01537C5.41575 2.21146 5.1605 2.49188 4.99492 2.82509L1.54492 9.71509M5.54492 13.7151H5.55492M9.54492 13.7151H9.55492",
    stroke: "#1B2028",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.75324990fe1a3dc08cdde24e5d13f260.svg";
export { ForwardRef as ReactComponent };